import type { JobPostingProduct } from '../../reducers/entitlement/entitlement'
import type { JobPostingPackage } from '../../reducers/packages/packages'

import { WebshopPackage } from '../../../schema/webshop-package'
import { getPackageDefinitionId, getProductDefinitionId } from '../../../util/get-definition/getDefinition'
import { isJobPosting } from './getUpgradesByJobPosting'

const getJobPostingPackageByEntitlement = (
  suggestiblePackages: WebshopPackage[],
  jobPostingProduct: JobPostingProduct,
): JobPostingPackage | undefined =>
  suggestiblePackages
    .reduce(
      (acc, val): JobPostingPackage[] => (isJobPosting(val) ? [...acc, val as JobPostingPackage] : acc),
      [] as JobPostingPackage[],
    ) // @ts-ignore
    .find(jobPostingPackage => getPackageDefinitionId(jobPostingPackage) === getProductDefinitionId(jobPostingProduct))

export default getJobPostingPackageByEntitlement
